export default __webpack_public_path__ + "static/media/home-imge-phone.aa6ad183.png";